



























































































































































































































import { AuthStoreHelper, NotificationStoreHelper, RootStoreHelper, StoreHelper } from '../../core/mixins';
import store, { AuthEvent, GetterType } from '../../../store';
import { Component, Prop, Vue, Emit, Mixins, Watch } from 'vue-property-decorator';
import { formatDate, removeIndexFromList } from '../../core/utils';
import { EventBus, TypeEventBus } from '../../core/utils';
import SeeImageOnModal from '../../core/components/SeeImageOnModal.vue';
import Button from '../../core/components/Button.vue';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';

import moment from 'moment';
import Axios from 'axios';
import { InsuranceServices } from '../../insurance/api/InsuranceServices';

@Component({
    components: {
        Button,
        DeleteConfirmation,
        SeeImageOnModal
    }
})
export default class ListEvents extends Mixins(AuthStoreHelper, StoreHelper, RootStoreHelper, NotificationStoreHelper) {
    @Prop() comments: any[];
    @Prop({ default: 'No hay eventos para mostrar' }) noOptionsText: string;
    @Prop({ default: false }) processingRequest: boolean;
    @Prop({ default: false }) deleteComment: boolean;
    @Prop({ default: false }) editableComment: boolean;
    @Prop({ default: false }) addComment: boolean;
    @Prop({ default: false }) addImage: boolean;
    @Prop({ default: false }) enableCheck: boolean;
    seeImage: boolean = false;
    imgPath: string = '';
    existsPublicImages: string = 'Ya existen imagenes publicas para esta chacra.';
    commentToEdit: number = -1;
    editingComment: object = {};
    commentImagesList: Array<object> = [];
    imageData: string = '';
    imageInfoToForcePublic: object = {};
    newImagesToAdd: string[] = [];

    userComment: string = '';
    //delete confirmation
    confirmationDelete: boolean = false;
    loadingIgnoredPeriods: boolean = false;
    deleteModalTitle: string = '';
    deleteBody: string = '';

    mounted() {}

    updateUserComment(value) {
        this.userComment = value;
    }
    updateCommentImages(value) {
        this.commentImagesList = value;
    }

    updateCommentId(value) {
        this.commentToEdit = value;
    }

    submitComment() {
        let self = this;
        if (this.commentToEdit == -1) {
            this.addNewComment(this.userComment, this.newImagesToAdd);
        } else {
            this.commentImagesList = [];
            let updatedNote = {
                id: this.commentToEdit,
                text: this.userComment,
                ...(this.editingComment && this.editingComment['public']
                    ? { public: this.editingComment['public'] }
                    : {})
            };
            this.modifyComment(
                updatedNote,
                self.newImagesToAdd
            );
        }
        this.clearNote();
    }
    removeImageAdded(indexToRemove){
        this.newImagesToAdd.splice(indexToRemove, 1);
    }

    isMyComment(comment){
        return this.$_getUserName === comment.created_by.username
    }


    addImageToExistingComment(){
        // console.log("agrego imagenes a comentario existente");
    }

    addImageToCurrentOnes(newImage: string){
        this.newImagesToAdd.push(newImage)
        // console.log("addImageToCurrentOnes", newImage);
    }

    previewImages(event) {
    let self = this;
      // Reference to the DOM input element
      let input = event.target;
      // Ensure that you have a file before attempting to read it
    //   console.log("input.files", input.files);
      for (let i = 0; i < input.files.length; i++) {
            const file = input.files[i];
            const reader = new FileReader();
            if (file.size > 20 * 1024 * 1024) {
                this.$_showHistoricalError("Una de las imágenes es muy grande (mayor a 20MB)");
            }else{
                reader.onload = function(e:any) {
                    const img = new Image();
                    self.addImageToCurrentOnes(e.target.result)
                    document.body.appendChild(img);
                };
                reader.readAsDataURL(file);
            }
        }
       event.target.value = ''; 
    }

    showImageBig(imgData){
        // console.log("showImageBig", imgData);
        //url de imagen de amazon
        this.imgPath = imgData['signed_url'],
        this.seeImage = true;   
    }

    seeBigImageRecentlyAdded(image){
        //la imagen recien agregada esta en base64
        this.imgPath = image,
        this.seeImage = true;   
    }


    @Emit()
    checkBoxAction(comment) {
        return comment;
    }

    clearNote(){
        this.clearImagesAdded();
        this.updateCommentId(-1);
        this.updateUserComment('');
    }

    clearImagesAdded(){
        this.newImagesToAdd = [];
        this.commentImagesList = [];
    }

    @Emit()
    addNewComment(userComment, newImagesToAdd) {
        this.clearImagesAdded();
    }
    @Emit()
    updateRanchNotes() {}

    patchImageNoteAction(imageInfo, publicValue: boolean, forcePublic:boolean){
        let self = this;
        let config = {
            public: publicValue,
            force_public: forcePublic
        }
        InsuranceServices.patchImageNote(
            imageInfo['id'],
            config
        ).then(res => {
            // this.$_showAddPointOfInterest(res.data.message);
            this.updateRanchNotes();
            this.imageInfoToForcePublic = {};
        }).catch(err => {
            if(err && err.response && err.response.data && err.response.data.message === self.existsPublicImages){
                this.showForcePublicAlert(imageInfo);
            }else{
                this.updateRanchNotes();
                this.imageInfoToForcePublic = {};
            }
        }) 
    }

    showForcePublicAlert(imageInfo){
        let self = this;

        this.imageInfoToForcePublic = imageInfo;
        this.showDeleteConfirmationDialog(
            self.existsPublicImages,
            'Solo 1 imagen puede ser Pública en cada Chacra<br><br>¿Desea dejar únicamente esta imagen como pública?<br><br>Las otras imágenes de esta chacra pasarán a ser privadas.'
        );
    }

    showDeleteConfirmationDialog(title, msgBody) {
        this.deleteModalTitle = title;
        this.deleteBody = msgBody;
        this.confirmationDelete = true;
    }

    confirmPublicAction(value) {
        if (value) {
            this.confirmationDelete = false;
            this.patchImageNoteAction(this.imageInfoToForcePublic, true, true);
        } else {
            //vuelvo a marcar la imagen clickeada con public false
            this.markPreviousClickedImageAsPublicFalse()
            this.confirmationDelete = false;
        }
    }

    markPreviousClickedImageAsPublicFalse(){
        for (let index = 0; index < this.comments.length; index++) {
            const commentImages = this.comments[index]['images'];
            let imageIndex = commentImages.findIndex(image => image['id'] === this.imageInfoToForcePublic['id'])
            if(imageIndex !== -1){
                this.$set(this.comments[index]['images'][imageIndex], 'public', false);
                break;
            }
        }
    }

    toggleImagePublic(imageInfo) {
        let publicValue = imageInfo.public;
        this.patchImageNoteAction(imageInfo, publicValue, false);
    }

    @Emit()
    deleteCommentary(id) {
        return id;
    }

    @Emit()
    deleteImage(imageId, imageIndex) {
       this.commentImagesList.splice(imageIndex, 1);
    }

    @Emit()
    modifyComment(commentToEdit, newImagesToAdd) {
        this.clearImagesAdded();
    }

    editComment(comment) {
        this.editingComment = comment;
        this.updateCommentId(comment['id']);
        this.updateUserComment(comment['text']);
        if(comment && comment['images']){
            this.updateCommentImages(comment['images']);
        }
    }

    format(date: string) {
        return formatDate(date);
    }

    keyUpComment() {
        if (this.userComment !== '') {
            this.$_disableListenkey;
        }
    }
}
